export default __webpack_public_path__ + "static/media/break.98072b17.svg";